import angular from 'angular';
import StringUtilsService from './stringUtils.service';

const StringUtilsModule = angular.module('stringUtils', [])
  .service('stringUtilsService', StringUtilsService);

export default StringUtilsModule;



// WEBPACK FOOTER //
// ./app/common/stringUtils/stringUtils.js